(() => {
  if (customElements.get('gb-tee-picks')) return;
  let adding = false;
  class TeePicks extends HTMLElement {
    connectedCallback() {
      if (this.loaded) return;
      this.loaded = true;
      this.load();
      this.addEventListener('change', e => {
        if (!e.target.matches('[data-pick-size]')) return;
        const card = e.target.closest('.gb-pick');
        card.querySelector('[data-pick-add]').disabled = !e.target.value;
        if (e.target.value) card.querySelector('[data-pick-price]').textContent = e.target.selectedOptions[0].dataset.price;
      });
      this.addEventListener('click', e => {
        const button = e.target.closest('[data-pick-add]');
        if (button) this.add(button);
      });
    }
    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-gb-picks-content]');
        if (!content?.querySelector('.gb-pick') || !this.isConnected) return;
        this.replaceChildren(content);
        this.hidden = false;
      } catch (_) { /* Keep checkout available when suggestions cannot load. */ }
    }
    async add(button) {
      if (adding) return;
      const card = button.closest('.gb-pick');
      const select = card.querySelector('[data-pick-size]');
      const status = card.querySelector('[data-pick-status]');
      if (!select.value) return;
      adding = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: Number(select.value), quantity: 1}]})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Could not add this tee. Please try again.');
        status.textContent = 'Added to your cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        status.textContent = error.message;
        button.disabled = false;
      } finally {
        adding = false;
        button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('gb-tee-picks', TeePicks);
})();
